import React, { useState } from "react";
import { DatePicker } from "../../../../shared";
import { MaintenanceTable } from "./Table";

const EquipmentMaintenance = ({
  equipment,
  maintenanceHistory,
  tableConfig,
}) => {
  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleDateChange = (value) => {
    setSelectedDate(value);
  };

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="flex shrink-0 flex-row items-center justify-between border-b border-gray-100 bg-white px-1 pb-3">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">
            Maintenance records
          </h2>
          <p className="text-sm text-gray-500">
            Service history and scheduled work for this unit
          </p>
          {/* <div>
            <DatePicker
              value={selectedDate}
              onChange={handleDateChange}
              placeholder="Select a date"
              format="MM/dd/yyyy"
            />
          </div> */}
        </div>
      </div>
      <div className="min-h-0 flex-1 pt-2">
        <MaintenanceTable
          equipment={equipment}
          maintenanceHistory={maintenanceHistory}
          tableConfig={tableConfig}
        />
      </div>
    </div>
  );
};

export default EquipmentMaintenance;
